// http://stackoverflow.com/a/34890276

/* eslint-disable no-param-reassign */
export default function groupBy(arrayOfObjects, keyToGroupBy) {
  return arrayOfObjects.reduce((returnValue, val) => {
    (returnValue[val[keyToGroupBy]] = returnValue[val[keyToGroupBy]] || []).push(val);
    return returnValue;
  }, {});
}
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./~/gwi-api/src/utils/group-by.js